import chroma from "chroma-js";

const MuiChip: any = {
  styleOverrides: {
    colorSuccess: {
      color: "#FFF",
    },
    colorError: {
      color: "#FFF",
    },
  },
};

export default MuiChip;
